import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Glampoints = (
  {
    size,
    fill,
    className,
    id,
    logo,
    opacity,
    outerStroke,
    innerStroke
  }
) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <g>
        <path d="M9.318,37.582l28.263,-28.264c4.09,3.784 6.418,9.11 6.418,14.681c0,10.972 -9.028,20 -20,20c-5.571,0 -10.897,-2.328 -14.681,-6.417Z" fill={fill} fillOpacity={opacity} />
        <g>
          <path d="M24,4c10.972,0 20,9.028 20,20c0,10.972 -9.028,20 -20,20c-10.972,0 -20,-9.028 -20,-20c0,-10.972 9.028,-20 20,-20Z" fill={"none"} />
          <path d="M24,6.5c-2.364,0 -4.655,0.462 -6.811,1.374c-2.084,0.881 -3.955,2.144 -5.563,3.752c-1.608,1.608 -2.871,3.479 -3.752,5.563c-0.912,2.156 -1.374,4.447 -1.374,6.811c0,2.364 0.462,4.655 1.374,6.811c0.881,2.084 2.144,3.955 3.752,5.563c1.608,1.608 3.479,2.871 5.563,3.752c2.156,0.912 4.447,1.374 6.811,1.374c2.364,0 4.655,-0.462 6.811,-1.374c2.084,-0.881 3.955,-2.144 5.563,-3.752c1.608,-1.608 2.871,-3.479 3.752,-5.563c0.912,-2.156 1.374,-4.447 1.374,-6.811c0,-2.364 -0.462,-4.655 -1.374,-6.811c-0.881,-2.084 -2.144,-3.955 -3.752,-5.563c-1.608,-1.608 -3.479,-2.871 -5.563,-3.752c-2.156,-0.912 -4.447,-1.374 -6.811,-1.374m0,-2.5c11.046,0 20,8.954 20,20c0,11.046 -8.954,20 -20,20c-11.046,0 -20,-8.954 -20,-20c0,-11.046 8.954,-20 20,-20Z" fill={outerStroke || fill} />
        </g>
        <g>
          <circle cx="24.001" cy="24" r="15" fill={"none"} />
          <circle cx="24.001" cy="24" r="14.583" fill={"none"} stroke={innerStroke || fill} strokeWidth={"0.83px"} />
        </g>
        <path d="M23.85,17.019l-0.742,0.741l0.006,0l-6.102,6.102l-0.54,0.541l0.316,0.315l6.323,6.322l0.741,0.742l0.297,-0.297l0.024,-0.019l5.19,-5.192l0.639,-0.637l-0.313,-0.313l-5.108,-5.107l-0.734,-0.734l-0.304,0.305l-0.013,0.011l-4.285,4.286l-0.313,0.313l0.513,0.513l4.417,4.416l0.629,-0.633l-4.295,-4.295l3.655,-3.655l4.896,4.897l-4.884,4.882l-6.118,-6.118l6.118,-6.118l6.75,6.75l0.629,-0.633l-6.64,-6.641l-0.752,-0.744Z" fill={logo || fill} />
      </g>
    </svg>
  );
};

Glampoints.defaultProps = {
  size: 48,
  fill: "#00e381",
  logo: undefined,
  innerStroke: undefined,
  outerStroke: undefined,
  opacity: 0.1,
  className: "",
  id: ""
};

Glampoints.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  opacity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
